import React, { useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import type { Schemes, Theme } from 'venn-ui-kit';
import { getImageTheme, getTypographyTheme, useColorTheme } from '../themes';

const ShellThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const typography = getTypographyTheme('default');

  const { colors, customColors, setCustomColors, setDebugColors } = useColorTheme();

  const images = useMemo(() => getImageTheme(), []);
  const schemes = useMemo(
    (): Schemes => ({
      FactorColors: {
        mainColor: colors.DivergingColor.B3,
        comparisonColor: colors.DivergingColor.A3,
        labelColor: colors.GreyScale.Grey90,
      },
      BarChartColors: {
        mainColor: colors.StudioSubjectColor.A1,
        secondaryColor: colors.StudioSubjectColor.A2,
        comparisonColor: colors.StudioSubjectColor.A3,
        lineColor: colors.GreyScale.Grey20,
      },
      LineChartColors: {
        mainColor: colors.StudioSubjectColor.A1,
        secondaryColor: colors.StudioSubjectColor.A2,
        comparisonColor: colors.StudioSubjectColor.A3,
        lineColor: colors.GreyScale.Grey20,
      },
      Proxy: {
        proxyLine: colors.DEPRECATED_DataLineColor.PaleGold,
        darkProxyLine: colors.DEPRECATED_DataLineColor.Gold,
        extrapolation: colors.DEPRECATED_DataLineColor.PaleBlue,
        subjectLine: colors.Black,
        invertedSubjectLine: colors.White,
        badgeText: colors.White,
        badgeBg: colors.PaleGold,
      },
    }),
    [colors],
  );

  const theme: Theme = useMemo(
    () => ({
      Images: images,
      Typography: typography,
      Colors: colors,
      Schemes: schemes,
      customColors,
      setCustomColors,
      setDebugColors,
      inPrintMode: false,
      inPrintModeOrReportLab: false,
    }),
    [images, typography, colors, schemes, customColors, setCustomColors, setDebugColors],
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ShellThemeProvider;
